import {FC, PropsWithChildren} from "react";

const Centered: FC<PropsWithChildren> = ({children}) => (
  <div className="flex items-center min-h-[50vh] md:min-h-[70vh] justify-center">
    {children}
  </div>
)

export default Centered;
